export const sortPostsByDate = postsArray => {

  if (typeof postsArray === 'undefined') return null

  const newPostsArray = [].concat(postsArray);
  
  return newPostsArray.sort((a, b) => {
    if (a.created_at > b.created_at) {
      return -1;
    }
    if (a.created_at < b.created_at) {
      return 1;
    }
  });
};





// WEBPACK FOOTER //
// ./src/selectores/posts.js